import React, { useState } from "react";
import { Link } from "react-router-dom";
import CredentialForm from "./CredentialForm";
import "../styles/createCredential.css";

export default function CreateCredential() {
    const [credential, setCredential] = useState({});
    const [successful, setSuccessful] = useState(true);

    return (
        <main className="create-credential">
            <Link className="back-link" to="/">← All credentials</Link>
            <div className="info-container">
                <h1>Add a credential</h1>
                <p>
                    Save a customer login. Company, provider, username and password are required.
                </p>
                <p>
                    Once saved, use the credential’s page link in CRM instead of copying the password.
                </p>
            </div>
            <CredentialForm
                method="create"
                credential={credential}
                setCredential={setCredential}
                successful={successful}
                setSuccessful={setSuccessful}
                editMode={true}
            />
            {!successful && (
                <div className="warning-message">
                    <h4>Warning</h4>
                    <p>
                        It's best to only save credentials we know are working.
                    </p>
                </div>
            )}
        </main>
    );
}
